import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  position: fixed;
  height: auto;
  width: 194px;
  display: none;
  left: 100px;
  margin-top: 50px;
  z-index: 99999999;
  border-radius: 8px;
  flex-direction: column;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.322));
  padding: 8px;

  &.toTop {
    transform: translateY(-100%);
    margin-top: 0px;
  }
  &.toTop .tooltipTriangle {
    bottom: 0px;
    top: unset;
    rotate: 0deg;
  }
  .tooltipTriangle {
    position: absolute;
    top: 0px;
    transform: translateY(8px);
    rotate: 180deg;
    left: calc(50% - 8px);
  }
  .tooltipTriangle svg {
    display: block;
    fill: #fff;
  }
  .tooltipLine .tooltipColor {
    width: 6px;
    height: 6px;
    border-radius: 3px;
  }
`;
